import React from 'react'
import MoveflexClubImg from '../../../assets/icons/moveflex-club-icon.png'
import MoveflexClubImgPb from '../../../assets/icons/moveflex-club-icon-pb.png'
import { StyledIcon } from './styled-icon.style'

const style = {
	width: '100%',
	display: 'flex'
}

/**
 * @param {boolean} disabled
 * if true, set the img to black and white
 */
const MoveflexClubIcon = ({ disabled, className }) => (
	<StyledIcon className={className} style={style}>
		<img src={disabled ? MoveflexClubImgPb : MoveflexClubImg} />
	</StyledIcon>
)

export default MoveflexClubIcon
